import { Link } from 'react-router-dom'

import { BsArrowRight } from 'react-icons/bs'

import FooterNav from '@/Navigation/FooterNav'

import Image from '@Pure/Image'

import { agences_infos } from '@shared/options.js';


export default function Footer ()
{
	const TODAY = new Date().getFullYear();

	const agencies = agences_infos.map((agency) => {

		let postal_code_city = agency.postalCode + " " + agency.city;

		let formatted_tel = agency.tel.match(/.{2}/g).join(' ');

		return (
			<div className="footer__agency" key={ agency.streetAddress }>
				<h5 className="footer-top__agence">
					{ agency.name }
				</h5>
				<p className="footer-top__agence--info">
					{ agency.streetAddress }
				</p>
				<p className="footer-top__agence--info">
					{ postal_code_city }
				</p>
				<a href={ "tel:" + agency.tel } className="footer-top__link">
					{ formatted_tel }
				</a>
			</div>
		);
	});

	return (
		<footer className="footer">

			<div className="footer-top">

				<div className="footer-top--logo">
					<Image src="/images/logo/logo-osaba-blanc.svg" className="footer-top--logo__svg" />
					<div className="footer-top--logo__text">
						<span className="osaba">
							OSABA
						</span>
						<span>
							Deux agences. Un même territoire.
						</span>
						<span>
							Une même exigence depuis plus de 20 ans.
						</span>
					</div>
				</div>

				{
					agencies
					? agencies
					: undefined
				}

				<div className='u-margin-top-15'>
					<Link to="/contact" className="footer-top__contact">
						NOUS CONTACTER
						<BsArrowRight />
					</Link>
				</div>

			</div>

			<div className="footer-bottom">
				<FooterNav />
				<p className="u-no-margins">
					&copy;
					{' '}
					{ TODAY }
					{' '}
					Osaba Immobilier. Tous droits réservés.
				</p>
			</div>

		</footer>
	);
}

